var map = {
	"./accounts-room.jpg": 68,
	"./accounts-team.jpg": 69,
	"./article1-image.png": 329,
	"./article2-image.png": 330,
	"./article3-image.png": 331,
	"./article4-image.png": 332,
	"./case-cockpit.jpg": 70,
	"./case-final-exam.jpg": 71,
	"./case-meeting-rooms.jpg": 72,
	"./case-norwegian-1.jpg": 73,
	"./case-norwegian-2.jpg": 74,
	"./case-novair.jpg": 75,
	"./case-pelesys-1.jpg": 76,
	"./case-pelesys-2.jpg": 77,
	"./case-realestate.jpg": 78,
	"./case-yachts.jpg": 79,
	"./clients/air-berlin.svg": 90,
	"./clients/air-canada.svg": 91,
	"./clients/cae.svg": 92,
	"./clients/h.svg": 93,
	"./clients/norwegian.svg": 94,
	"./clients/novair.svg": 95,
	"./clients/pelesys.png": 96,
	"./clients/raddison.svg": 97,
	"./clients/ryanair.svg": 98,
	"./clients/sas.svg": 99,
	"./clients/skistar.svg": 100,
	"./clients/tui.svg": 101,
	"./clients/wax.svg": 102,
	"./clouds.png": 333,
	"./learn-test-export.jpg": 80,
	"./logos.png": 334,
	"./mountains-big.jpg": 81,
	"./mountains-small-taggis.jpg": 82,
	"./mountains-small.jpg": 83,
	"./new-laptop.jpg": 35,
	"./taggis-and-docbrowser.jpg": 84,
	"./taggis-and-docbrowser.png": 335,
	"./taggis-brochure.jpg": 36,
	"./towed-plane.png": 336,
	"./trial-mac-old.png": 337,
	"./trial-mac.jpg": 85,
	"./upload-visuals-old.jpg": 86,
	"./upload-visuals.png": 338,
	"./video-see-how.jpg": 87,
	"./video-watch-taggis.jpg": 88
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 328;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = 328
// module chunks = 3